import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useScreenShare, useDailyEvent } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { screenShareAtom, screenShareSelectAtom } from '../../State';
import isElectron from '../../Global';

const DetectScreenShare = React.memo(() => {
  const { screens, isSharingScreen } = useScreenShare();
  const [screenShareState, setScreenShareState] = useRecoilState(screenShareAtom);
  const [selectedState, setSelectedState] = useRecoilState(screenShareSelectAtom);
  //スクリーンシェアでエラーが起きた場合
  // useDailyEvent(
  //   'track-started',
  //   useCallback((ev) => {
  //     console.log('ここよばれてる');
  //     if (ev.participant.screenVideoTrack !== 'undefined') {
  //       console.log(ev);
  //       let videoTrack = ev.track;
  //       console.log(videoTrack.getSettings());
  //     }
  //   }, []),
  // );

  useEffect(() => {
    detectScreen(screens);
  }, [screens]);

  function detectScreen(screens) {
    //スクリーンの数がゼロの場合
    if (screens.length < 1) {
      setScreenShareState(null);
      return;
    }

    //undefinedのチェック
    if (
      typeof screens[0].screenVideo !== 'undefined' &&
      typeof screens[0].screenVideo.persistentTrack !== 'undefined'
    ) {
    } else {
      setScreenShareState(null);
      return;
    }

    //ビデオトラック
    let videoTrack = screens[0].screenVideo.persistentTrack;

    //console.log('スクリーン');
    //console.log(screens[0]);

    // if (
    //   typeof videoTrack.getSettings() !== 'undefined' &&
    //   typeof videoTrack.getSettings().height !== 'undefined'
    // ) {
    // } else {
    //   //処理停止
    //   return;
    // }

    //getSettingsが取得できるかどうか
    if (typeof videoTrack.getSettings() == 'undefined') {
      setTimeout(() => {
        detectScreen();
      }, 100);
      return;
    }

    if (typeof videoTrack.getSettings().width == null) {
      setTimeout(() => {
        detectScreen();
      }, 100);
      return;
    }

    //同じ内容で再レンダリングしないため
    if (screenShareState != null) {
      //既に同様のスクリーンが設定されている場合は処理しない
      if (screenShareState.videoUniqueID === videoTrack.id) {
        return;
      }
    }

    //ローカルユーザーの場合に、全体表示化どうかを確認
    var isWholeScreen = detectWholeScreen();

    //エレクトロンの場合はfalseに
    if (isElectron && !selectedState.includes('screen:')) {
      isWholeScreen = false;
    }

    let audioTrack;
    if (screens[0].screenAudio.state == 'playable') {
      audioTrack = screens[0].screenAudio.persistentTrack;
    }

    setScreenShareState({
      screenID: screens[0].session_id,
      persistentTrack: videoTrack,
      audioTrack: audioTrack,
      isWholeScreen: isWholeScreen,
      videoUniqueID: videoTrack.id,
    });
  }

  //全体共有化どうかの検知
  function detectWholeScreen() {
    if (screens.length > 0) {
      if (screens[0].local) {
        if (screens[0].screenVideo != null) {
          if (screens[0].screenVideo.track != null) {
            if (screens[0].screenVideo.track.label != null) {
              const label = screens[0].screenVideo.track.label;

              // console.log('スクリーン状況');
              // console.log(label);
              if (label.includes('screen:') || label.includes('Screen')) {
                return true;
              }
            }
          }
        }
      }
      return false;
    }
  }

  //レンダービュー
  return false;
});

export default DetectScreenShare;
